import { useState, useEffect } from "react"
import { useNavigate, useLocation } from "react-router-dom"
import { 
  LuBriefcase, 
  LuFolderKanban, 
  LuMail, 
  LuArrowRight, 
  LuCircleHelp,
  LuDatabase,
  LuContact,
  LuShield
} from "react-icons/lu"
import "./Navbar.css"

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false)
  const [logoLoaded, setLogoLoaded] = useState(false)

  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "auto"
  }, [menuOpen])

  const handleLogoClick = () => {
    setMenuOpen(false)

    if (location.pathname !== "/home") {
      navigate("/home")
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" })
    }
  }

  return (
    <>
      <div 
        className={`mobile-overlay ${menuOpen ? "active" : ""}`} 
        onClick={() => setMenuOpen(false)}
      />

      <div className="navbar-wrapper">
        <nav className="navbar">

          <div 
            className="nav-left"
            onClick={handleLogoClick}
            style={{ cursor: "pointer" }}
          >
            {!logoLoaded && <div className="logo-skeleton"></div>}

            <img
              src="/assets/logo.png"
              alt="logo"
              className={`nav-logo ${logoLoaded ? "logo-show" : "logo-hide"}`}
              onLoad={() => setLogoLoaded(true)}
            />
          </div>

          <div className={`nav-links ${menuOpen ? "active" : ""}`}>
            <button className="nav-link" onClick={() => { navigate("/services"); setMenuOpen(false); }}>
              <LuBriefcase className="nav-icon" />
              Services
            </button>

            <button className="nav-link" onClick={() => { navigate("/database"); setMenuOpen(false); }}>
              <LuDatabase className="nav-icon" />
              Database
            </button>

            <button className="nav-link" onClick={() => { navigate("/about"); setMenuOpen(false); }}>
              <LuCircleHelp className="nav-icon" />
              About
            </button>

            <button className="nav-link" onClick={() => { navigate("/contact"); setMenuOpen(false); }}>
              <LuContact className="nav-icon" />
              Contact
            </button>

            <button className="nav-link security-btn" onClick={() => { navigate("/security"); setMenuOpen(false); }}>
              <LuShield className="nav-icon" />
              Security
            </button>

            <button className="get-started-btn" onClick={() => { navigate("/signup"); setMenuOpen(false); }}>
              <LuArrowRight className="nav-icon" />
              Get Started
            </button>
          </div>

          <div
            className={`hamburger ${menuOpen ? "active" : ""}`}
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <span></span>
            <span></span>
            <span></span>
          </div>

        </nav>
      </div>
    </>
  )
}

export default Navbar